import React from 'react';
import MergedPage from '../components/nav/MergedPage';
import ManageUsers from './ManageUsers';
import Teams from './Teams';
import ManageTeams from './ManageTeams';

// Staff (Sep 2026 nav restructure): the former Staff, My Team and Team
// Management pages as tabs. Each tab mounts the untouched legacy page.
export default function StaffPage() {
  const tabs = [
    { key: 'all', label: 'All Staff', render: () => <ManageUsers /> },
    { key: 'my-team', label: 'My Team', render: () => <Teams /> },
    { key: 'teams', label: 'Manage Teams', render: () => <ManageTeams /> },
  ];
  return <MergedPage tabs={tabs} defaultTab="all" testId="staff-page" />;
}
